/**
 * Strings the moderation area shares.
 *
 * It is one surface now — the comment queue — and this file is what that surface
 * holds in common with the console chrome around it. The report surfaces that
 * used to sit beside it took their own vocabulary with them onto the case
 * detail, including the `case_states` reading («بانتظار المُبلِّغ») that only
 * ever existed to word one value differently from the case queue's. One queue,
 * one reading.
 */
export const sharedCopy = {
  crumbs: {
    console: 'لوحة التشغيل',
  },

  action: {
    cancel: 'ألغِ',
  },
} as const;
